export default __webpack_public_path__ + "static/media/audio_48_reloj.c9662447.mp3";